/**
 * This class "PageHooks" is used to call views hooks
 * (beforeLeave, afterLeave, beforeEnter, afterEnter).
 * 
 * This is to facilitate code injection within the SPA to
 * initialize next.container, but the script might be delayed
 * by the network.
 * 
 * Can be used un 2 ways.
 * 
 * =============================================================
 * 
 * class MyClass extends PageHooks {
 *     constructor() {
 *         super()
 *     }
 *     beforeEnter(data) { }
 *     afterEnter(data) { }
 *     beforeLeave(data) { }
 *     afterLeave(data) { }
 * }
 * 
 * =============================================================
 * 
 * class MyClass extends MyOtherClass {
 *     constructor() {
 *         super()
 *         const beforeEnter = this.beforeEnter.bind(this)
 *         new class extends PageHooks {
 *             beforeEnter(data) {
 *                 beforeEnter(data)
 *             }
 *         }
 *     }
 *     beforeEnter(data) { }
 * }
 * 
 * =============================================================
 * 
 */

import barba from '@barba/core'

const BEFORE_LEAVE = "beforeLeave"
const AFTER_LEAVE = "afterLeave"
const BEFORE_ENTER = "beforeEnter"
const AFTER_ENTER = "afterEnter"

let lastData = null
let lastHook = null

barba.hooks.beforeLeave(data => {
    lastHook = BEFORE_LEAVE
    lastData = data
})

barba.hooks.afterLeave(data => {
    lastHook = AFTER_LEAVE
    lastData = data
})

barba.hooks.beforeEnter(data => {
    lastHook = BEFORE_ENTER
    lastData = data
})

barba.hooks.afterEnter(data => {
    lastHook = AFTER_ENTER
    lastData = data
})

class PageHooks {
    constructor() {
        // We missed the "beforeEnter" hook
        if (lastData && lastHook && lastHook === BEFORE_ENTER) {
            this.beforeEnter(lastData)
        }

        // We missed the "beforeEnter" and "afterEnter" hooks
        if (lastData && lastHook && lastHook === AFTER_ENTER) {
            this.beforeEnter(lastData)
            this.afterEnter(lastData)
        }
        
        barba.hooks.beforeLeave(this.beforeLeave.bind(this))
        barba.hooks.afterLeave(this.afterLeave.bind(this))
        barba.hooks.beforeEnter(this.beforeEnter.bind(this))
        barba.hooks.afterEnter(this.afterEnter.bind(this))
    }
    beforeLeave(data) { }
    afterLeave(data) { }
    beforeEnter(data) { }
    afterEnter(data) { }
}

export { PageHooks }
export default PageHooks